const SearchReservedId = ({ show }) =>
  show ? <div id='search_reverseId' /> : null;

export default SearchReservedId;
